<template>
  <div class="all-rename-diag">
    <upload-diag
      :isShow="isShow"
      :title="title"
      :uploadaction="uploadaction"
      @close="close">
    </upload-diag>
  </div>
</template>
<script>
import uploadDiag from '@/components/dialogs/uploadDiag'
export default {
  name: 'allRenameDiag',
  components: { uploadDiag },
  props: {
    isShow: Boolean,
    uploadaction: String
  },
  data() {
    return {
      title: '批量上传别名'
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
